import * as React from 'react';
import CssBaseline from '@mui/material/CssBaseline';

//Common
import '@ingka/base/style.scss';
import '@ingka/svg-icon/style.scss';
import '@ingka/focus/style.scss';
import '@ingka/skeleton/style.scss';
import '@ingka/segmented-control/dist/style.css';
//Components
import '@ingka/status/style.scss';
import '@ingka/accordion/dist/style.css';
import '@ingka/button/style.scss';
import '@ingka/carousel/style.scss';
import '@ingka/choice/style.scss';
import '@ingka/tabs/style.scss';
import '@ingka/text/style.scss';
import '@ingka/tooltip/style.scss';
import '@ingka/combobox/style.scss';
import '@ingka/toggle/dist/style.css';
import '@ingka/hyperlink/style.scss';
import '@ingka/list-box/style.scss';
import '@ingka/link-list/style.scss';
import '@ingka/modal/style.scss';
import '@ingka/search/style.scss';
import '@ingka/jumbo-button/style.scss';
import '@ingka/tag/style.scss';
import '@ingka/forms/dist/style.css';
import '@ingka/commercial-message/style.scss';
import '@ingka/pill/style.scss';
import '@ingka/inline-message/style.scss';
import '@ingka/loading/style.scss';
import '@ingka/switch/style.scss';
import '@ingka/avatar/style.scss';
import '@ingka/base/dist/style.css';
import '@ingka/badge/style.scss';
import '@ingka/toast/style.scss';
import '@ingka/card/style.scss';
import '@ingka/base/style.scss';
import '@ingka/list-view/style.scss';
// CWDS Components
import '@ingka-group-digital/cwds-react-app-switcher/style.css';
import '@ingka-group-digital/cwds-react-header/style.css';
import '@ingka-group-digital/cwds-react-layout/style.css';
import '@ingka-group-digital/cwds-react-mobile-navigation/style.css';
import '@ingka-group-digital/cwds-react-nav-menu/style.css';
import '@ingka-group-digital/cwds-react-shared-app-symbol/style.css';
import '@ingka-group-digital/cwds-react-shared-modal/style.css';
import '@ingka-group-digital/cwds-react-shared-nav/style.css';
import '@ingka-group-digital/cwds-react-shared-tabs/style.css';
import '@ingka-group-digital/cwds-react-user-profile/style.css';

const GlobalStyle = () => (
  <React.Fragment>
    <CssBaseline />
  </React.Fragment>
);

export default GlobalStyle;
